module.exports = __webpack_public_path__ + "/static/assets/ba5625a05f8ae4818d871287530dcfa9.gif";